import { SearchResultsAlt, TopicSearch } from '~/components/Search/types'

import { PortalProducts } from '../types/analytics.type'
import FormAnalytics from '../formAnalytics/formAnalytics'
import { FormNames } from '../formAnalytics/formEvents.types'

import { OnboardingEvents } from './onboardingEvents.types'

class OnboardingAnalytics extends FormAnalytics {
  public constructor() {
    super(PortalProducts.ONBOARDING, FormNames.ONBOARDING_DETAILS)
  }

  public logCloseCustomizeExpModal(closeVia: 'not_now_btn' | 'escape_key'): void {
    this.logEvent({
      event: OnboardingEvents.CLOSE_CUSTOMIZE_EXPERIENCE_MODAL,
      close_via: closeVia,
    })
  }

  public logAutoRedirectingUser(from: string, destination: string, reason: string): void {
    this.logEvent({
      event: OnboardingEvents.AUTO_REDIRECT_USER,
      product: PortalProducts.NAVIGATION,
      from,
      destination,
      reason,
    })
  }

  public logExitOnboardingFlow(from: string): void {
    this.logEvent({
      event: OnboardingEvents.EXIT_ONBOARDING_FLOW,
      step: from,
    })
  }

  public logSkipOnboardingStep(stepPath: string, skipTo: string): void {
    this.logEvent({
      event: OnboardingEvents.SKIP_ONBOARDING_STEP,
      step: stepPath,
      skip_to: skipTo,
    })
  }

  public logCompleteOnboardingStep(stepPath: string, goingTo: string): void {
    this.logEvent({
      event: OnboardingEvents.COMPLETE_ONBOARDING_STEP,
      step: stepPath,
      next_step: goingTo,
    })
  }

  public logSelectAccountType(field: string, option: string | number): void {
    this.logEvent({
      event: OnboardingEvents.SELECT_ACCOUNT_TYPE,
      field,
      value: option,
    })
  }

  public logHomMethodsPopup(val: boolean): void {
    this.logEvent({
      event: val ? OnboardingEvents.HOM_METHODS_OPEN : OnboardingEvents.HOM_METHODS_CLOSE,
    })
  }

  public logCheckbox(field: string, isChecked: boolean): void {
    this.logEvent({
      event: OnboardingEvents.CHECKBOX,
      field,
      checked: isChecked,
    })
  }
  public logWantToDoButtonClick(
    label: string,
    name: string,
    button_target_location: string,
    page_location: string,
  ): void {
    this.logEvent({
      button_lable: label,
      button_name: name,
      button_target_location,
      event: OnboardingEvents.BUTTONCLICK,
      page_location,
    })
  }
  public logVCCformMenuClick(page_location: string, bootcamp_id: string): void {
    this.logEvent({
      bootcamp_id,
      event: OnboardingEvents.VCC_FROM_MENU,
      page_location,
    })
  }
  public logVCCfromSearchClick(
    page_location: string,
    bootcamp_id: string,
    search_query: string,
    list_items: TopicSearch[] | SearchResultsAlt[],
  ): void {
    this.logEvent({
      bootcamp_id,
      event: OnboardingEvents.VCC_FROM_SEARCH,
      list_items,
      page_location,
      search_query,
    })
  }
  public logProductVideoWatched(duration: number, completed: boolean): void {
    this.logEvent({
      event: OnboardingEvents.PRODUCT_VIDEO_WATCHED,
      duration,
      completed,
    })
  }
}

const onboardAnalytics = new OnboardingAnalytics()

export default onboardAnalytics
